
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("heHIK", function(module, exports) {
/* ViewPageLabels.tsx generated by @compiled/babel-plugin v0.40.0 */ /** @jsxFrag React.Fragment */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $jmjWc = parcelRequire("jmjWc");



const $27714532592c5c9e$export$cde283d9c6ce8eac = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "7b0qH",
    name: "LazyPageLabelsAutomationDiscovery",
    loader: async ()=>(await (parcelRequire("kdk2A"))).PageLabelsAutomationDiscovery
});



var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $1d2ww = parcelRequire("1d2ww");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $luv00 = parcelRequire("luv00");


var $9wGTI = parcelRequire("9wGTI");


var $aIhWb = parcelRequire("aIhWb");


var $luf2A = parcelRequire("luf2A");

const $8e15c05fdec90b85$var$ViewPageLabelsContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDefaultWidth: isDefaultWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18s8krf6 _1bsb1osq",
            __cmplp.isDefaultWidth ? "_p12fukw8" : "_p12fn7od",
            __cmplp.className
        ])
    });
});
const $8e15c05fdec90b85$var$controlStyles = {
    root: "_18s81lfs _bfhkvuon _5g471j28 _q4zt1l7x _858u1l7x _jyzf1l7x _4cvx1l7x _1di6vuon _jomrvuon _10j7vuon _irr3vuon"
};
const $8e15c05fdec90b85$var$viewPageStyles = {
    container: (provided)=>({
            ...provided,
            margin: `0 -10px ${"var(--ds-space-200, 16px)"}`
        }),
    control: (provided)=>({
            ...provided,
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            '&:hover, &:focus, &:active, &:focus-within': {
                backgroundColor: "var(--ds-surface, #FFFFFF)",
                borderColor: "var(--ds-border, #0B120E24)"
            },
            ':not(&:focus-within, :hover)': {
                borderColor: 'transparent'
            }
        }),
    menu: (provided)=>({
            ...provided,
            zIndex: 5
        })
};
const $8e15c05fdec90b85$export$1fbe6b34890db860 = ({ pageWidthType: pageWidthType, contentId: contentId, spaceKey: spaceKey })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [shouldDisplayAutomationDiscovery, setShouldDisplayAutomationDiscovery] = (0, $cozmU.useState)(false);
    const labelsRef = (0, $cozmU.useRef)(null);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const memoizedComponents = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            Control: (props)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $luf2A.CustomControl), {
                    ...props,
                    xcss: $8e15c05fdec90b85$var$controlStyles.root
                });
            }
        }), []);
    (0, $cozmU.useEffect)(()=>{
        // unmount LazyPageLabelsAutomationDiscovery if the user navigates to another page
        if (shouldDisplayAutomationDiscovery) setShouldDisplayAutomationDiscovery(false);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    const checkShouldDisplayAutomationDiscovery = (0, $cozmU.useCallback)(()=>{
        // Automation is a premium feature
        if (edition === (0, $euL71.ConfluenceEdition).PREMIUM || (0, $9wGTI.fg)('a4c_free_and_standard_editions')) {
            const hasDismissedDiscoveryMessage = (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_ADD_LABEL_TO_PAGE); // Don't render the experience if they've already seen and dismissed it
            if (!hasDismissedDiscoveryMessage) {
                setShouldDisplayAutomationDiscovery(true);
                experienceTracker.start({
                    name: (0, $irVI7.AUTOMATION_DISCOVERY_ADD_LABEL_EXPERIENCE)
                });
            }
        }
    }, [
        edition,
        experienceTracker
    ]);
    const hideDiscoveryMessage = ()=>{
        setShouldDisplayAutomationDiscovery(false);
    };
    const openLabels = (e)=>{
        // prevents text from being entered when pressing shortcut key
        e.preventDefault();
        labelsRef.current?.focus();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        id: contentId,
        name: (0, $irVI7.VIEW_PAGE_LABELS_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e15c05fdec90b85$var$ViewPageLabelsContainer, {
        isDefaultWidth: JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT,
        "data-testid": "view-page-labels-container",
        "data-vc": "view-page-labels-container",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.LABELS_SHORTCUT),
        accelerator: (0, $gnkil.UNIVERSAL_LABELS_SHORTCUT),
        listener: openLabels
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aIhWb.LabelsSelect), {
        key: `labels-select-${contentId}`,
        source: "viewPage",
        experienceName: (0, $irVI7.VIEW_PAGE_LABELS_EXPERIENCE),
        contentId: contentId,
        spaceKey: spaceKey,
        styles: $8e15c05fdec90b85$var$viewPageStyles,
        components: memoizedComponents,
        ref: labelsRef,
        maxMenuHeight: 208,
        onAdded: checkShouldDisplayAutomationDiscovery
    }), shouldDisplayAutomationDiscovery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $27714532592c5c9e$export$cde283d9c6ce8eac), {
        spaceKey: spaceKey,
        onDismiss: hideDiscoveryMessage,
        onProceed: hideDiscoveryMessage
    })));
};
const $8e15c05fdec90b85$export$1fb1c7df85f70fdd = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).DISCO
})($8e15c05fdec90b85$export$1fbe6b34890db860);
module.exports["ViewPageLabelsComponent"] = $8e15c05fdec90b85$export$1fbe6b34890db860;
module.exports["ViewPageLabels"] = $8e15c05fdec90b85$export$1fb1c7df85f70fdd;

});

parcelRegister("kdk2A", function(module, exports) {

let $eb74913768ea457a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $eb74913768ea457a$var$load("6wr18"),
    $eb74913768ea457a$var$load("ffEVr"),
    $eb74913768ea457a$var$load("24OMS"),
    $eb74913768ea457a$var$load("hhss7"),
    $eb74913768ea457a$var$load("lbsQO"),
    $eb74913768ea457a$var$load("djzzD")
]).then(()=>parcelRequire('a0meM'));

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("cPt0K"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("cPt0K", function(module, exports) {

let $9570c06e3b725460$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9570c06e3b725460$var$load("3kVph"),
    $9570c06e3b725460$var$load("hhss7"),
    $9570c06e3b725460$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});


//# sourceMappingURL=ViewPageLabels.9aa3aa70.js.map
